// Developer Vault block on a project page: briefings linked to the project in Admin → Training.

// The briefing's own lesson page (the Vault list ignores ?v=).
export const briefingLessonPath = (video: { slug?: string | null; id: string }): string =>
  `/training/${encodeURIComponent(video.slug || video.id)}`;

// Shown while loading, then only when the project has at least one linked briefing.
export const showProjectBriefings = (s: {
  projectId: string | null | undefined;
  signedIn: boolean;
  isLoading: boolean;
  isFetched: boolean;
  count: number;
}): boolean => !!s.projectId && s.signedIn && (s.isLoading || (s.isFetched && s.count > 0));
